import { Component } from '@theme/component';
import { QuickAddComponent } from './quick-add.js';
import { StandardEvents } from '@shopify/events';

import '@theme/levayo-rating';

class LevayoCardPurchase extends Component {
  #controller;
  #busy = false;

  connectedCallback() {
    super.connectedCallback();
    this.#controller = new AbortController();
    this.addEventListener(StandardEvents.cartLinesUpdate, this.#cartUpdate, { signal: this.#controller.signal });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller?.abort();
  }

  /** @param {Event} event */
  selectVariant(event) {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement) || this.#busy) return;
    const option = select.selectedOptions[0];
    if (!option || option.disabled) return;
    this.querySelector('input[name="id"]').value = option.value;
    this.querySelector('input[name="quantity"]').value = option.dataset.minimum;
    this.querySelector('product-form-component').dataset.quantityDefault = option.dataset.minimum;
    this.querySelector('[data-card-money]').textContent = option.dataset.price;
    const price = Number(option.dataset.priceNumber);
    const compare = Number(option.dataset.compareNumber);
    const onSale = price > 0 && compare > price;
    this.querySelector('[data-card-discount]').hidden = !onSale;
    this.querySelector('[data-card-compare]').textContent = option.dataset.compare;
    this.querySelector('[data-card-saving]').textContent = onSale ? `−${Math.round((compare - price) * 100 / compare)} %` : '';
    const deal = this.closest('.lvh-card')?.querySelector('.lvh-card__deal');
    if (deal) deal.hidden = !onSale;
  }

  #cartUpdate = event => {
    if (event.action !== 'add' || !event.promise || !this.contains(event.target)) return;
    const button = this.querySelector('[data-card-add]');
    if (!button) return;
    const select = this.querySelector('[data-card-variant]');
    this.#busy = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (select) select.disabled = true;
    event.promise.catch(() => {}).finally(() => {
      this.#busy = false;
      if (!this.isConnected) return;
      button.disabled = false;
      button.removeAttribute('aria-busy');
      if (select) select.disabled = false;
    });
  };
}

if (!customElements.get('levayo-card-purchase')) customElements.define('levayo-card-purchase', LevayoCardPurchase);

class LevayoCardQuickAdd extends QuickAddComponent {
  constructor() {
    super();
    const nativeClick = this.handleClick;
    this.handleClick = async event => {
      try { await nativeClick(event); }
      catch { window.location.assign(this.productPageUrl); }
    };
  }
  get productPageUrl() { return this.dataset.productUrl || super.productPageUrl; }
  async fetchProductPage(url) {
    const page = await super.fetchProductPage(url);
    // Custom product templates without the native modal fragment retain the normal variant page.
    if (!page?.querySelector('[data-product-grid-content]')) throw new Error('Use product variant page');
    return page;
  }
}
if (!customElements.get('levayo-card-quick-add')) customElements.define('levayo-card-quick-add', LevayoCardQuickAdd);
